import { KeyRound, Database, Bot, ScrollText } from 'lucide-react';
import { SitePage, COMPANY } from './SiteChrome';
import { useI18n } from '@/lib/i18n';
import { Reveal } from './reveal';
import './pages.css';

/**
 * Security page. Every claim here has to be something the code actually does —
 * this is the page a quality department will hold us to.
 */
export default function Security() {
  const { t, fill } = useI18n();

  const groups = [
    {
      icon: <KeyRound size={18} />,
      title: t.site.security.accessTitle,
      points: [t.site.security.access1, t.site.security.access2, t.site.security.access3, t.site.security.access4],
    },
    {
      icon: <Database size={18} />,
      title: t.site.security.dataTitle,
      points: [t.site.security.data1, t.site.security.data2, t.site.security.data3, t.site.security.data4],
    },
    {
      icon: <Bot size={18} />,
      title: t.site.security.aiTitle,
      points: [t.site.security.ai1, t.site.security.ai2, t.site.security.ai3],
    },
    {
      icon: <ScrollText size={18} />,
      title: t.site.security.trailTitle,
      points: [t.site.security.trail1, t.site.security.trail2, t.site.security.trail3],
    },
  ];

  return (
    <SitePage>
      <section className="site-section">
        <div className="site-shell">
          <Reveal>
            <div className="section-head">
              <h1 className="section-title">{t.site.security.title}</h1>
            </div>
          </Reveal>

          <div className="feature-grid security-groups">
            {groups.map((group, i) => (
              <Reveal key={group.title} delay={i * 0.05}>
                <div className="ins-finding">
                  <div className="security-finding-head">
                    <span className="feature-icon">{group.icon}</span>
                    <h2 className="ins-finding-title">{group.title}</h2>
                  </div>
                  <ul className="spec-list">
                    {group.points.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="prose" style={{ marginTop: 'var(--space-10)' }}>
            <h2>{t.site.security.contactTitle}</h2>
            <p>{fill(t.site.security.contactLead, { email: COMPANY.email })}</p>
          </div>
        </div>
      </section>
    </SitePage>
  );
}
